import isServer from 'detect-node';
export var safeRaf = isServer
    ? setImmediate
    : requestAnimationFrame.bind(window);
